import React from 'react';
import Content from '../dashboard/Content';
import CreateTab from './CreateTab';
import UpdateTab from './UpdateTab';
import Tabs from '../widgets/tab/Tabs';
import TabPane from '../widgets/tab/TabPane';

import './Collection.scss';

export default class Collection extends React.Component {

  render() {
    return (
      <Content title="بانک اطلاعاتی">
        <div className="row h-100">
          <div className="col-xxl-9 col-12 mx-auto h-100">
            <Tabs defaultActive="1">
              <TabPane key="1" text="ایجاد">
                <CreateTab />
              </TabPane>
              <TabPane key="2" text="بروزرسانی">
                <UpdateTab />
              </TabPane>
            </Tabs>
          </div>
        </div>
      </Content>
    );
  }

}
